import type { TrackingProperties } from '@/lib/analytics/tracking-props'

// Read the server-rendered arm, including in previews. Do not infer the
// rendered design from a browser cookie that may have changed in another tab.
export const hubLayoutTracking = (root: HTMLElement): TrackingProperties => {
  const hub = root.querySelector<HTMLElement>('[data-hub-team-layout]')
  const layout = hub?.dataset.hubTeamLayout
  const experimentId = hub?.dataset.hubTeamExperiment
  const variant = hub?.dataset.hubTeamVariant
  return {
    ...(layout === 'full' || layout === 'after-starters' ? { reviewTeamLayout: layout } : {}),
    ...(experimentId && (variant === 'a' || variant === 'b') ? { experimentId, experimentVariant: variant } : {}),
  }
}
